export default function PopupDivider(props: {color?: string, className?: string}) : JSX.Element {
    const color = props.color ?? "gray_lines"
    return <>
        <div className={"bg-" + color + " h-px w-full "+props.className} />
    </>
}